// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import api from './utils/api.js'
import { Apis } from './api/index'
import Utils from '@/utils/util.js'
import phoneCall from '@/utils/phoneCall.js'
import Nodes from '@/utils/nodes.js'
import store from '@/utils/store.js'
import SearchBar from '@/components/searchBar/index'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VCharts from 'v-charts'
import './style/index.scss'
import '../static/fonts/iconfont.css'
import VueQuillEditor from 'vue-quill-editor'
// require styles 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'


Vue.use(VueQuillEditor)
Vue.use(api)
Vue.use(ElementUI);
Vue.component('search-bar', SearchBar);
Vue.use(VCharts)
Vue.config.productionTip = false
Vue.prototype.Utils = Utils;
Vue.prototype.$util = Utils;
Vue.prototype.phoneCall = phoneCall;
Vue.prototype.Nodes = Nodes;
Vue.prototype.$ajax = Apis;
Vue.prototype.baseURL = process.env.API_ROOT;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  components: { App },
  template: '<App/>',

})
/*
//获取全局状态
 store.state.token_type
 更改全局状态
 this.$store.commit('settoken','')
 */



// WEBPACK FOOTER //
// ./src/main.js